import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from '../../../modules/infra/i18n';
import HeaderDropdown from './containers/HeaderDropdown';
import CustomersList from './customersList/customersList';
import * as customerActions from './actions';
import SearchHeader from '../headers/searchHeader';
import {
  getAllCustomers,
  filteredCustomers,
  getLetter,
  getLettersPagination,
} from './selector';
import CustomersFilter from './customersFilter/customersFilter';
import Queue from '../../queue/QueueContainer';
import { canUserViewCustomersReport } from '../../common/helpers/users';
import LocateDuplicatesButton from './duplicateRecords/LocateDuplicates/LocateDuplicatesButton';
import KnowledgeArticleLink from '../../common/KnowledgeArticleLink';
import { EXPORT_CLIENTS_HELP_URL } from '../../common/KnowledgeArticleLink/constants';
import { CustomerGroups } from '../../../modules/shared/engage/customer-groups';

const Customers = ({
  link,
  selectedLetter,
  letters,
  selectLetter,
  customers,
  showLoading,
  customerCount,
  lettersPagination,
  onPageChange,
  user,
  shopKind,
}) => (
  <div>
    <SearchHeader
      heading={t('customers:header.heading')}
      button={t('customers:header.add_client_button')}
      type="customer"
      link={link}
      dropdown={<HeaderDropdown title={t('customers:header.dropdown_title')} />}
      visibleInContainerApp
    />

    <div className="c-wrapper o-page-height">
      <CustomerGroups />
      <div>
        <CustomersFilter
          selectedLetter={selectedLetter}
          letters={letters}
          selectLetter={selectLetter}
        />
        <div className="c-separator u-mv"/>

        <div className="layout c-wrapper-allow-header u-pb">
          <div className="layout__item u-1/2">
            <span className="c-label c-label--strong u-fontsize-normal">
              {t('customers:total_a_z', { customerCount })}
            </span>
          </div>
          <div className="layout__item u-1/2 u-text-right">
            <LocateDuplicatesButton className="u-mr-">
            <span className="c-btn__text">
              {t('customers:locate_duplicates_button')}
            </span>
            </LocateDuplicatesButton>
            <Queue
              name="reports"
              jobName="customer-report"
              label={t('customers:client_report_label')}
              btnLabel={t('customers:download_button')}
              display-if={canUserViewCustomersReport(user, shopKind)}
            />
            <KnowledgeArticleLink
              url={EXPORT_CLIENTS_HELP_URL}
              showTooltipOnTheLeft
            />
          </div>
        </div>

        <span className="c-label c-label--strong u-fontsize-normal">
          {t('customers:total_count', { count: lettersPagination.count })}
        </span>
        <p className="c-label c-label--strong u-fontsize-normal">
          {t('customers:page_info', { page: lettersPagination.page, totalPages: lettersPagination.totalPages })}
        </p>
        <CustomersList
          customers={customers}
          showLoading={showLoading}
          onPageChange={onPageChange}
          pagination={lettersPagination}
        />
      </div>
    </div>
  </div>
);
Customers.propTypes = {
  letters: PropTypes.arrayOf(PropTypes.object),
  selectLetter: PropTypes.func,
  customers: PropTypes.arrayOf(PropTypes.object),
  showLoading: PropTypes.bool,
  link: PropTypes.string,
  customerCount: PropTypes.number,
  lettersPagination: PropTypes.object.isRequired,
  selectedLetter: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  shopKind: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  flags: PropTypes.object.isRequired,
};
Customers.defaultProps = {
  selectedLetter: '',
  enabledLetters: [],
  selectLetter: () => null,
  customers: [],
  showLoading: false,
  letters: [],
  link: '',
  customerCount: 0,
};

class CustomersContainer extends Component {
  componentWillMount() {
    this.props.fetchLetters();
    this.props.fetchCustomers(this.props.selectedLetter);
  }

  onPageChange = page =>
    this.props.fetchCustomers(this.props.selectedLetter, page)

  selectLetter = (letter) => {
    if (letter === this.props.selectedLetter) return;
    this.props.selectLetter(letter);
    this.props.fetchCustomers(letter);
  }

  render() {
    return (
      <Customers
        {...this.props}
        selectLetter={this.selectLetter}
        onPageChange={this.onPageChange}
      />
    );
  }
}

CustomersContainer.propTypes = {
  fetchLetters: PropTypes.func.isRequired,
  fetchCustomers: PropTypes.func.isRequired,
  selectLetter: PropTypes.func.isRequired,
  selectedLetter: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  allCustomers: getAllCustomers(state),
  customers: filteredCustomers(state),
  selectedLetter: getLetter(state),
  lettersPagination: getLettersPagination(state),
  letters: state.customers.letters,
  customerCount: state.customers.customerCount,
  showLoading: state.main.loading_in_progress,
  shop: state.auth.shop,
  user: state.auth.user,
  shopKind: state.auth.shopKind,
});

const mapDispatchToProps = {
  getAllCustomers,
  selectLetter: customerActions.selectLetter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomersContainer);
